import type { ReactNode } from "react";

type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  align = "left",
}: Props) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        centered ? "md:flex-col md:items-center md:text-center" : ""
      }`}
    >
      <div className={centered ? "max-w-2xl" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">{desc}</p>
        )}
      </div>
      {action}
    </div>
  );
}